import axios from "axios";
import { headersProvider } from "../apiHelpers";
import constants from "../constants";

export const getAllClauseLibrary = () =>
  axios.post(
    `${constants.apiHost}/clauselibrary/getAll`,
    {},
    {
      headers: headersProvider(),
    },
  );

export const createClauseLibrary = ({ title }) =>
  axios.post(
    `${constants.apiHost}/clauselibrary/create`,
    {
      title,
    },
    {
      headers: headersProvider(),
    },
  );

export const createClause = ({ title, text, tags, clauseLibraryId }) =>
  axios.post(
    `${constants.apiHost}/clauselibrary/clause/create`,
    {
      title,
      text,
      tags,
      clauseLibraryId,
    },
    {
      headers: headersProvider(),
    },
  );

export const getClauseLibraryById = ({ id }) =>
  axios.get(`${constants.apiHost}/clauselibrary/${id}`, {
    headers: headersProvider(),
  });

export const getClauseById = ({ id }) =>
  axios.get(`${constants.apiHost}/clauselibrary/clause/${id}`, {
    headers: headersProvider(),
  });

export const updateClauseById = ({ id, title, text, newTags, removedTags }) =>
  axios.put(
    `${constants.apiHost}/clauselibrary/clause/edit/${id}`,
    {
      title,
      text,
      newTags,
      removedTags,
    },
    {
      headers: headersProvider(),
    },
  );

export const deleteClauseLibrary = ({ clauseLibraryId }) =>
  axios.delete(`${constants.apiHost}/clauselibrary/delete/${clauseLibraryId}`, {
    headers: headersProvider(),
  });

export const deleteClause = ({ clauseId }) =>
  axios.delete(`${constants.apiHost}/clauselibrary/clause/delete/${clauseId}`, {
    headers: headersProvider(),
  });
